"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XWALLET = exports.WEB3_WALLET = exports.WATCH_ONLY = exports.TREZOR = exports.SECALOT = exports.PRIV_KEY = exports.MNEMONIC = exports.MEW_CONNECT = exports.LEDGER = exports.KEYSTORE = exports.KEEPKEY = exports.BITBOX = void 0;
var LEDGER = 'ledger';
exports.LEDGER = LEDGER;
var TREZOR = 'trezor';
exports.TREZOR = TREZOR;
var BITBOX = 'bitbox';
exports.BITBOX = BITBOX;
var SECALOT = 'secalot';
exports.SECALOT = SECALOT;
var KEEPKEY = 'keepkey';
exports.KEEPKEY = KEEPKEY;
var MEW_CONNECT = 'mew_connect';
exports.MEW_CONNECT = MEW_CONNECT;
var KEYSTORE = 'keystore';
exports.KEYSTORE = KEYSTORE;
var MNEMONIC = 'mnemonic';
exports.MNEMONIC = MNEMONIC;
var WEB3_WALLET = 'web3_wallet';
exports.WEB3_WALLET = WEB3_WALLET;
var PRIV_KEY = 'priv_key';
exports.PRIV_KEY = PRIV_KEY;
var WATCH_ONLY = 'watchOnly';
exports.WATCH_ONLY = WATCH_ONLY;
var XWALLET = 'xwallet';
exports.XWALLET = XWALLET;